import { Request } from '../../Servidor/Request';

export class VisitTypeRequest {
    private sgeptipovisita: number;
    private nome: string;
    private codigo: string

    constructor(sgeptipovisita: number, nome: string, codigo: string) {
        this.sgeptipovisita = sgeptipovisita;
        this.nome = nome;
        this.codigo = codigo;
    }


    /**
     * Getter sgeptipovisita
     * @return {number}
     */
    public getSgeptipovisita(): number {
        return this.sgeptipovisita;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
     /**
     * Getter codigo
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class VisitTypeStructRequest {
    private sgeptipovisita: number;

    constructor(sgeptipovisita: number) {
        this.sgeptipovisita = sgeptipovisita;
    }


    /**
     * Getter sgeptipovisita
     * @return {number}
     */
    public getSgeptipovisita(): number {
        return this.sgeptipovisita;
    }

}

export class VisitTypeStructResponse {
    private sgeptipovisita: number;
    private nome: string;

    constructor(sgeptipovisita: number, nome: string) {
        this.sgeptipovisita = sgeptipovisita;
        this.nome = nome;
    }


    /**
     * Getter sgeptipovisita
     * @return {number}
     */
    public getSgeptipovisita(): number {
        return this.sgeptipovisita;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class VisitTypeInteractor {
    public fetchSave(request: VisitTypeRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/tipo-visita/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: VisitTypeStructRequest): PromiseLike<VisitTypeStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/tipo-visita/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}